export default __webpack_public_path__ + "static/media/leadership-involvement-1.c81fce5e.svg";